import React from "react"
import "./CircleLine.styles.scss"

type CircleLineProps = {
	height: number
	width: number
	children?: React.ReactNode
	backgroundColor: React.CSSProperties["color"]
}

const CIRCLE_MIN_WIDTH = 10
const START_POSITION = 0
const HEIGHT_CONTAINER = 20

const CircleLine = (props: CircleLineProps) => {
	const { height, width, children, backgroundColor } = props
	const circleRadius = height / 2

	return (
		<div className="circle-line">
			<svg width={width + CIRCLE_MIN_WIDTH} height={HEIGHT_CONTAINER}>
				<rect
					x={START_POSITION}
					y={height}
					fill={backgroundColor}
					stroke={backgroundColor}
					width={width}
					height={height / circleRadius}
				/>
				<circle
					cx={width}
					cy={height}
					fill={backgroundColor}
					stroke={backgroundColor}
					width={CIRCLE_MIN_WIDTH}
					height={CIRCLE_MIN_WIDTH}
					r={circleRadius}
				/>
			</svg>
			{children}
		</div>
	)
}

export default CircleLine
